/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { DaypartResult } from '../../models/daypart-result';
import { HalJson } from '../../models/hal-json';

export interface DaypartsDaypartIdGet$Params {
  'Active-Tenant-Identifier': string;
  daypartId: string;
}

export function daypartsDaypartIdGet(http: HttpClient, rootUrl: string, params: DaypartsDaypartIdGet$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'_links'?: HalJson;
} & DaypartResult>> {
  const rb = new RequestBuilder(rootUrl, daypartsDaypartIdGet.PATH, 'get');
  if (params) {
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.path('daypartId', params.daypartId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/hal+json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      '_links'?: HalJson;
      } & DaypartResult>;
    })
  );
}

daypartsDaypartIdGet.PATH = '/dayparts/{daypartId}';
